import { AppConstants } from "@/common";
import { useHomePageStore } from "@/stores/HomePage";

const {
	fetchMovies,
	fetchOlympics,
	fetchSports,
	fetchKids,
	fetchNews,
	fetchContinueWatching,
	fetchRecentlyOnDemand,
	fetchWatchAgain,
	fetchRecentChannels,
	fetchTrends,
	fetchLiveSeries,
} = useHomePageStore();


export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {
		const { lineViewRows } = useAppConfig();
		
		lineViewRows.home.forEach((key) => {
			switch (key) {
				case AppConstants.shelfKeys.trendsCards:
					fetchTrends().catch(() => {});
					break;
				case AppConstants.shelfKeys.recentChannelsCards:
					fetchRecentChannels().catch(() => {});
					break;
				case AppConstants.shelfKeys.olympicsCards:
					fetchOlympics().catch(() => {});
					break;
				case AppConstants.shelfKeys.moviesCards:
					fetchMovies().catch(() => {});
					break;
				case AppConstants.shelfKeys.sportsCards:
					fetchSports().catch(() => {});
					break;
				case AppConstants.shelfKeys.kidsCards:
					fetchKids().catch(() => {});
					break;
				case AppConstants.shelfKeys.newsCards:
					fetchNews().catch(() => {});
					break;
				case AppConstants.shelfKeys.continueWatchingCards:
					fetchContinueWatching().catch(() => {});
					break;
				case AppConstants.shelfKeys.watchAgainCards:
					fetchWatchAgain().catch(() => {});
					break;
				case AppConstants.shelfKeys.recentlyOnDemandCards:
					fetchRecentlyOnDemand().catch(() => {});
					break
				case AppConstants.shelfKeys.liveSeries:
					fetchLiveSeries().catch(() => {});
					break
			}
		});
	}
});